<template>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                  <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        <template v-if="buildingId">
                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / {{ propertyName }}</span>
                        </template>
                        
                    </span>
                  <p style="
            font-size: 15px;
            font-family: inherit;
            font-weight: 500;

            text-transform: uppercase;
          ">
                      Payments
                  </p>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                        <router-link class="btn btn-table" :to="{
                  name: 'property',
                  params: { buildingId: buildingId, buildingName: buildingName },
                }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>

        </div>
        

        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col">Paid Date</th>
                        <th scope="col">Amount</th>
                        <th scope="col" class="text-center" style="">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- IT SHOULDBE HERE key in paginatedData but then it doesn't work. And lower the router links?-->

                    <tr v-for="(payment, key) in paginatedData"
                        v-bind:key="payment"
                        class="clickable-row">
                        <td scope="row">{{ ++key }}</td>
                        <td>{{ customFormatter(payment.paidDate) }}</td>
                        <td>{{ $filters.currency(payment.amount, "€") }}</td>
                        <td v-if="payment.expenseTypeId > 0" class="text-center">
                            <router-link style="display: inline-block; margin-left: 6px;" class="btn btn-table"
                                         :to="{
                  name: 'receiptowner',
                  params: {
                    id: payment.id,
                    propertyId: propertyId,
                    buildingId: buildingId,
                    buildingName: buildingName,
                    propertyName: propertyName,
                    expenseId: payment.expenseTypeId,
                  },
                }"><i class="fas fa-receipt"></i></router-link>
                        </td>
                        <td v-else class="text-center" style="text-align: right;">
                            <router-link style="display: inline-block; margin-left: 6px;" class="btn btn-table" :to="{
                  name: 'receiptowner',
                  params: {
                    id: payment.id,
                    propertyId: propertyId,
                    buildingId: buildingId,
                    buildingName: buildingName,
                    propertyName: propertyName,
                  },
                }"><i class="fas fa-receipt"></i></router-link>

                        </td>
                        <!--<td class="text-center">
                            <router-link style="display: inline-block; margin-left: 6px;" class="btn btn-table"
                                         :to="{
                  name: 'receiptowner',
                  params: {
                    id: payment.id,
                    propertyId: propertyId,
                    buildingId: buildingId,
                    buildingName: buildingName,
                    propertyName: propertyName,
                  },
                }"><i class="fas fa-receipt"></i></router-link>
                        </td>-->

                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
      <div class="col-12">
        <a
          @click="$router.go(-1)"
          class="btn btn-cancel"
          style="
            width: 60px;
            display: block;
            margin-left: auto;
            margin-right: 0;
            margin-bottom: 15px;
            margin-top: -5px;
          "
          >Back</a
        >
      </div>
      <div class="col-8 table-summary">
        <span>
          Showing {{ startEntry }} to {{ endEntry }} of
          {{ numberOfEntries }} entries
        </span>
      </div>
      <div class="col-4">
        <paginate
          :page-count="numberOfPages"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
    </div>
</template>
<script>
import { authenticationService } from "@/_services";
import { format, parseISO } from "date-fns";
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      payments: [],
    //  buildingId: 0,
   //   buildingName: "",
    //  propertyName: "",
    //  propertyId: 0,
      currentUser: null,
      pageNumber: 0,
      contact:[],
    };
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  mounted() {
    //this.fetchUserStatement();
    //this.buildingName = this.$route.params.buildingName;
      this.fetchStatement();
      this.getProperty();
  },
  methods: {
    fetchUserStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/statement/userstatement/owner?id=" + this.currentUser.id;
      this.$http
        .get(request, {
          id: this.currentUser.id,
        })
        .then(({ data }) => {
          this.mute = false;
          // console.log(data.building);
          //this.contacts = data.contacts;
          this.buildingId = data.building.id;
          //this.buildingName = data.building.name;
         // this.propertyName = data.property.propertyName;
          this.propertyId = data.property.id;
          this.fetchStatement();
          
        });
    },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/payments/receipts?id=" + this.property.id;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.payments = data.receipts;
        });
    },
    getProperty: function () {
      this.$http.get("/properties/" + this.propertyId).then((response) => {
        this.contact = response.data.contact;
      });
    },
    editItem: function (item) {
      this.$router.push({
        name: "committee",
        params: {
          id: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    deleteItem: function destroy(item) {
      var r = confirm("Are you sure you want to delete committee member?");
      if (r == true) {
        var _this = this;
        this.axios.delete("/committees/" + item.id).then(function () {
          _this.fetchStatement();
          // _this.getVueItems();
          //_this.hasDeleted = false
        });
      }
    },
    customFormatter(date) {
      return format(parseISO(date), "dd/MM/yyyy");
    },
    clickCallback(pageNum) {
      this.pageNumber = pageNum - 1;
    },
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: 10,
    },
    sortBy: {
      type: String,
      required: false,
      default: "Paid Date",
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      property:(state)=>state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingId(){
      if(this.property != null)
        return  this.property.buildingId;
      return ""
    },
    buildingName(){
      if(this.property != null)
        return  this.property.buildingName;
      return ""
    },
    propertyName(){
        if(this.property != null)
            return this.property.propertyName;
        return ""
    },
    propertyId(){
        if(this.property != null)
            return this.property.id;
        return ""
    },
    getPayments() {
      return this.payments;
    },

    numberOfEntries() {
      return this.getPayments.length;
    },

    numberOfPages() {
      let l = this.numberOfEntries,
        s = this.size;
      return Math.ceil(l / s);
    },
    startEntry() {
      if (this.numberOfEntries == 0) {
        return 0;
      }
      if (this.pageNumber + 1 == 1) {
        return 1;
      } else {
        return this.pageNumber * this.size + 1;
      }
    },
    endEntry() {
      if (this.numberOfEntries <= this.size) {
        return this.numberOfEntries;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 == 1) {
        return this.size;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 > 1) {
        if (this.numberOfEntries - this.size * (this.pageNumber + 1) > 0) {
          return this.size * (this.pageNumber + 1);
        } else {
          return this.numberOfEntries;
        }
      } else {
        return NaN;
      }
    },

    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      var payments = [...this.getPayments];
      //  var sortedPayments = this.getPayments;
      if (this.sortBy == "Date") {
        payments.sort((a, b) =>
          a.paidDate < b.paidDate ? 1 : b.paidDate < a.paidDate ? -1 : 0
        );
      } else {
        payments.sort((a, b) =>
          a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0
        );
      }
      return payments.slice(start, end);
    },
  },
};
</script>
